import cn from 'classnames'
import React, { DetailedHTMLProps } from 'react'

import { buttonCircleIcon } from './style.css'

interface Props extends DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  ariaLabel: string
  imgAlt?: string
}

const ButtonCircleIcon: React.FC<Props> = ({ ariaLabel, children, className, imgAlt, onClick }) => (
  <button
    aria-label={ariaLabel}
    className={cn(buttonCircleIcon, className)}
    data-testid={imgAlt || ariaLabel}
    onClick={onClick}
  >
    {children}
  </button>
)

export default ButtonCircleIcon
